import { createAction } from '../../../core/helpers'

import { FETCH_ROLES } from '../action-types'

const cleanupFetchRoles = createAction(FETCH_ROLES.CLEANUP)

export default cleanupFetchRoles
